import { AgResourceLanguage } from '../types';
import { cart as EnUsCart } from '../en-us/cart';

export const cart: AgResourceLanguage['cart'] = {
  ...EnUsCart,
  subscriptionTitle: 'Abonnement',
  oneTimeTitle: 'Achat Unique',
  giftCartTitle: 'Commande Cadeau',
  oneTimeDescription: 'Ces articles seront livrés avec votre première commande d’abonnement:',
  oneTimeCarouselTitle: 'Vous pourriez aussi aimer',
  clearCartText: 'Supprimer les produits',
  oneTimeCarouselAddButton: 'Ajouter',
  title: 'Votre Panier',
  checkoutButtonLabel: 'Passer à la caisse',
  emptyState: {
    oneTimeProductsTitle: 'Les favoris des membres',
    addOneTimeProductButton: 'Ajouter au Panier',
    label: 'Ajoutez des articles à votre panier'
  },
  emptyStateLabel: 'Ajoutez des articles à votre panier',
  frequencyLabel: 'Expédié tous les 30 jours:',
  deliveryInfo:
    'Une fois le paiement terminé, votre commande sera expédiée dans les 24 heures (L-V) après paiement. Prévoir jusqu’à 48 heures pendant le week-end et les jours fériés.',
  deleteItemModal: {
    title: 'Supprimer des articles du panier',
    description: 'Êtes-vous sûr de vouloir supprimer des articles de votre panier?'
  },
  clearCartModal: {
    title: 'Supprimer tous les articles du panier',
    description: 'Êtes-vous sûr de vouloir supprimer tous les articles de votre panier?'
  },
  free: 'Gratuit',
  scoopPrompt: 'Avez-vous besoin d’une cuillère avec votre sac? Ajoutez-la gratuitement ci-dessous.'
};
